var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length > 0)?_c('div',{staticClass:"select-row row"},[_c('div',{staticClass:"row__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"row__content"},_vm._l((_vm.data),function(item,key,index){return _c('span',{key:item.id,ref:"selectBtn",refInFor:true,staticClass:"select-btn",class:[
        { 'select-btn--active': item.id === _vm.value }, 
        _vm.type === 'datePhase' ? 'phase_box' : ''
      ],on:{"click":function($event){return _vm.handleClick({ id: item.id, type: _vm.type, index: index + 1 }, $event)}}},[(
          _vm.type === 'difficulties' &&
            Number(item.id) === Number(_vm.$route.query.difficulties) &&
            _vm.showDegreeTip
        )?_c('already-degree',{on:{"closeTip":function($event){return _vm.setShowDegreeTip(false)}}}):_vm._e(),_vm._v("\n      "+_vm._s(item.name)+"\n    ")],1)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e251e31","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CourseCenter/components/SelectRow.vue
// module id = 1014
// module chunks = 1